module.exports = __webpack_public_path__ + "static/media/jpg.36dcc70f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/assets/file icons/jpg.svg
// module id = 268
// module chunks = 0